import { Dropdown } from "antd";
import CustomImage from "../../components/CustomImage";
import useAuth from "../../hooks/useAuth";

const ProfileMenu = () => {
  const { logout } = useAuth();

  const items = [
    // {
    //   key: 'profile',
    //   label: 'My Profile',
    // },
    {
      key: "logout",
      label: "Logout",
      onClick: logout,
    },
  ];

  return (
    <Dropdown
      placement="bottomRight"
      arrow={{ pointAtCenter: true }}
      className="cursor-pointer"
      rootClassName="!left-auto !right-5 profile-dropdown"
      menu={{ items }}
    >
      <div className="flex items-center gap-2.5 cursor-pointer">
        <CustomImage
          size={40}
          src=""
          className="rounded-full border border-theme-slate-200"
        />
      </div>
    </Dropdown>
  );
};

export default ProfileMenu;
